/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CareUnitSettingsDTO
 */
export interface CareUnitSettingsDTO {
    /**
     * 
     * @type {string}
     * @memberof CareUnitSettingsDTO
     */
    carePrincipalId: string;
    /**
     * 
     * @type {string}
     * @memberof CareUnitSettingsDTO
     */
    cardTypeId: string;
}

export function CareUnitSettingsDTOFromJSON(json: any): CareUnitSettingsDTO {
    return CareUnitSettingsDTOFromJSONTyped(json, false);
}

export function CareUnitSettingsDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): CareUnitSettingsDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'carePrincipalId': json['carePrincipalId'],
        'cardTypeId': json['cardTypeId'],
    };
}

export function CareUnitSettingsDTOToJSON(value?: CareUnitSettingsDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'carePrincipalId': value.carePrincipalId,
        'cardTypeId': value.cardTypeId,
    };
}

